import React, { useState } from 'react';
import { Modal } from '../UI/Modal';
import { Button } from '../UI/Button';

interface NewAuditModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCreateAudit: (clientName: string, websiteUrl: string) => void;
}

export const NewAuditModal: React.FC<NewAuditModalProps> = ({
  isOpen,
  onClose,
  onCreateAudit,
}) => {
  const [clientName, setClientName] = useState('');
  const [websiteUrl, setWebsiteUrl] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!clientName.trim()) {
      setError('Please enter a client or business name.');
      return;
    }

    if (!websiteUrl.trim()) {
      setError('Please enter the client website URL.');
      return;
    }

    let formattedUrl = websiteUrl.trim();
    if (!formattedUrl.startsWith('http://') && !formattedUrl.startsWith('https://')) {
      formattedUrl = 'https://' + formattedUrl;
    }

    try {
      new URL(formattedUrl);
    } catch {
      setError('Please enter a valid website URL (e.g. https://example.com).');
      return;
    }

    setError('');
    onCreateAudit(clientName.trim(), formattedUrl);
    setClientName('');
    setWebsiteUrl('');
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Start New SEO Client Audit">
      <form onSubmit={handleSubmit}>
        <div style={{ fontSize: '13px', color: 'var(--text-muted)', marginBottom: '20px' }}>
          Initialize a new client audit powered by the Module 1 instructor methodology (Lectures 31–33).
        </div>

        {error && (
          <div
            style={{
              background: 'rgba(244, 63, 94, 0.12)',
              border: '1px solid var(--accent-red)',
              color: 'var(--accent-red)',
              padding: '10px 14px',
              borderRadius: 'var(--radius-sm)',
              fontSize: '13px',
              marginBottom: '16px',
            }}
          >
            {error}
          </div>
        )}

        <div className="form-group">
          <label className="form-label">Client Name / Business Name *</label>
          <input
            type="text"
            className="input-field"
            placeholder="e.g. ABC Construction Co."
            value={clientName}
            onChange={(e) => setClientName(e.target.value)}
            autoFocus
          />
        </div>

        <div className="form-group">
          <label className="form-label">Target Website Domain URL *</label>
          <input
            type="text"
            className="input-field"
            placeholder="e.g. https://nkfi.org or example.com"
            value={websiteUrl}
            onChange={(e) => setWebsiteUrl(e.target.value)}
          />
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '24px' }}>
          <Button variant="secondary" type="button" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" type="submit">
            Create & Start Audit
          </Button>
        </div>
      </form>
    </Modal>
  );
};
